class Sliders {
    private $_pageLinkBlocks        =   $(".page-link-block");

    public constructor() {
        if (this.$_pageLinkBlocks.length)
            this.initPageLinkBlocks();
    }

    private initPageLinkBlocks() {
        this.$_pageLinkBlocks.each((i, e) => {
            const slider = $(e).find(".slider");
            if (!slider.length)
                return;

            (<any>$(slider)).slick({
                fade: true,
                arrows: false,
                dots: false,
                autoplaySpeed: 2000,
                draggable: false,
                swipe: false,
                touchMove: false
            });

            $(e).mouseenter(() => {
                (<any>$(slider)).slick('slickPlay');
            }).mouseleave(() => {
                (<any>$(slider)).slick('slickPause');
                (<any>$(slider)).slick('slickGoTo', 0);
            });
        });
    }
}

export default Sliders;